import { createStyles } from '@mantine/core';
import { motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';
import { CSSObject } from 'styled-components';

import { useIsSidebarOpen } from '@portals/redux';

type MainProps = {
  className?: string;
  children: ReactNode;
  style?: CSSObject;
};

const Main: FC<MainProps> = ({ children }) => {
  const { classes, cx } = useStyles();
  const isSidebarOpen = useIsSidebarOpen();

  return (
    <motion.div
      className={cx(classes.main, 'page-main')}
      transition={{ duration: 0.15 }}
      initial={{ marginLeft: isSidebarOpen ? 300 : 76 }}
      animate={{ marginLeft: isSidebarOpen ? 300 : 76 }}
    >
      {children}
    </motion.div>
  );
};

const useStyles = createStyles((theme) => ({
  main: {
    position: 'relative',
    zIndex: 2,
    display: 'grid',
    gridTemplateRows: `${theme.other.navbarHeight}px 1fr`,
    height: '100vh',
    backgroundColor: theme.white,
    letterSpacing: '0.02em',
  },
}));

export default Main;
